import React from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import { useNavigate } from "react-router-dom";
import { slideFromLeftFadeIn } from "theme/Animations";
import { Item } from "features/header/types";
import { setPage } from "features/pagination/paginationSlice";
import { batch, useDispatch } from "react-redux";
import { setActiveFiltersCount } from "features/Filters/filtersSlice";

interface DrawerMenuItemProps {
  item: Item;
  delay: number;
  isBrand: boolean;
}

const DrawerMenuItem: React.FC<DrawerMenuItemProps> = ({
  item,
  delay,
  isBrand,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onPress = () => {
    isBrand &&
      batch(() => {
        dispatch(setPage(1));
        dispatch(setActiveFiltersCount(1));
      });
    window.scrollTo(0, 0);
    navigate(item.route ?? "/");
  };

  return (
    <DrawerMenuItemContainer delay={delay} onClick={onPress}>
      <Title>{item.title}</Title>
    </DrawerMenuItemContainer>
  );
};

const DrawerMenuItemContainer = styled.div<{ delay: number }>`
  min-height: ${toRem(40)};
  width: 100%;
  background-color: white;
  margin: 0.5px 0;
  border-left-style: solid;
  border-left-color: #f2f8fd;
  border-left-width: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  transform: translateX(-100%);
  animation: ${slideFromLeftFadeIn} 0.3s ease-in-out forwards;
  animation-delay: ${(props: any) => `${props.delay}s`};
`;

const Title = styled.div`
  margin: 0 10px;
  font-size: ${toRem(14)};
  line-height: 1.5;
`;

export default DrawerMenuItem;
